import { render, staticRenderFns } from "./ClassesTable.vue?vue&type=template&id=a3fa4416"
import script from "./ClassesTable.vue?vue&type=script&lang=js"
export * from "./ClassesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports